// src/Components/videochat/callChatUtils.js
//
// Reglas del chat dentro de la llamada. Las expresiones son las mismas del chat
// normal (ChatScreen.containsSensitiveInfo) para que se comporten igual.

export const MAX_MESSAGE_LENGTH = 1000

const EMAIL_REGEX = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/
const PHONE_REGEX = /(\+\d{1,3}[- ]?)?\d{2,4}[- ]?\d{3,4}[- ]?\d{3,4}/

export const containsSensitiveInfo = (text) => EMAIL_REGEX.test(text) || PHONE_REGEX.test(text)

// El servidor arma el texto del regalo: "🌹 Ana envió una Rosa (5 coins)".
const GIFT_TEXT_REGEX = /^(\S+)\s+(.+?)\s+envió\s+(?:un|una|unos|unas)\s+(.+?)\s*\((\d+)\s*coins?\)\s*$/
const GIFT_COINS_REGEX = /\((\d+)\s*coins?\)\s*$/

export const isGiftMessage = (m) =>
  m?.message_type === 'gift' || GIFT_COINS_REGEX.test(String(m?.message ?? ''))

// Coins que dice el texto de un regalo (0 si no es un regalo).
export const giftCoins = (m) => {
  const match = GIFT_COINS_REGEX.exec(String(m?.message ?? ''))
  return match ? parseInt(match[1], 10) : 0
}

export const parseGiftText = (text) => {
  const match = GIFT_TEXT_REGEX.exec(String(text ?? ''))
  if (!match) return null
  return { emoji: match[1], who: match[2], gift: match[3], coins: parseInt(match[4], 10) }
}

// Regalos recientes por usuario, en el dispositivo (iOS: recentGifts.{userId}).
const recentKey = (userId) => `recentGifts.${userId}`

export const loadRecentGiftIds = (userId) => {
  try {
    const raw = JSON.parse(localStorage.getItem(recentKey(userId)) || '[]')
    return Array.isArray(raw) ? raw : []
  } catch { return [] }
}

export const saveRecentGiftId = (userId, giftId) => {
  try {
    const next = [giftId, ...loadRecentGiftIds(userId).filter((id) => id !== giftId)].slice(0, 3)
    localStorage.setItem(recentKey(userId), JSON.stringify(next))
    return next
  } catch { return [giftId] }
}
